import { type ReactElement, useState } from 'react'
import { FileInputs, Page } from '@components'
import { isEmpty } from '@terros/common'
import { type VideoWithMetadata } from '@util'
import { FileListInterface } from './FileListInterface'
import { createFileRoute } from '@tanstack/react-router'

function UploadShortsPage(): ReactElement {
  const [files, setFiles] = useState<VideoWithMetadata[]>([])

  return (
    <Page>
      <Page.Heading title='Upload Shorts' />
      <Page.Content scrollArea>
        {isEmpty(files) ? <FileInputs setFiles={setFiles} /> : <FileListInterface files={files} setFiles={setFiles} />}
      </Page.Content>
    </Page>
  )
}

export const Route = createFileRoute('/short/upload/')({
  component: UploadShortsPage,
})
